export default __webpack_public_path__ + "static/media/flag-burkina-faso.af97f168.svg";